import { Component, ViewChild, ElementRef, OnInit, Input, Output, EventEmitter, ContentChildren, QueryList, TemplateRef, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';

import { AppTemplateDirective } from 'app/directive';
import { DataService } from 'app/services';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-content-overlay',
  templateUrl: './content-overlay.component.html',
  styleUrls: ['./content-overlay.component.scss'],
})
export class ContentOverlayComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() id: string = '';
  @Input() closeOnClickOutside: boolean = true;
  @Input() showOnHover: boolean = false;
  @Input() defaultState: boolean = false;
  @Input() dropshadow: boolean = false;
  @Input() showArrow: boolean = false;
  @Input() closeOnTab: boolean = true;
  // @Input() top: any = '31px';
  @Input() top: any = '22px';
  @Input() right: any = 0;
  @Input() arrowTop: any = '5px';
  // @Input() arrowTop: any = '15px';
  @Input() arrowRight: any = '50%';
  @Input() disabled: boolean = false;
  @Input() showOnTab: boolean = false;
  @Input() showOnClick: boolean = true;
  @Input() arrowColor: any = 'white'; // white, black
  @Input() stopPropagation: boolean = false;

  @Input('closeAfterAction')
  set closeAfterAction(data: any) {
    this.closeAfterActionFn();
  }

  @Output() appShow = new EventEmitter<any>();
  @Output() appHide = new EventEmitter<any>();

  @ViewChild('overlayContainer')
  overlayContainer: ElementRef;

  @ContentChildren(AppTemplateDirective) templates: QueryList<any>;

  isOverlayVisible: boolean = false;
  itemTemplate: TemplateRef<any>;
  overlayTemplate: TemplateRef<any>;
  clickOutsideListener: any;
  onKeyPressSub: Subscription;
  subscriptions: Subscription[] = [];

  constructor(private cdr: ChangeDetectorRef, private dataService: DataService) {}

  ngOnInit() {
    this.isOverlayVisible = this.defaultState;

    if (this.isOverlayVisible) {
      this.addEventListener();
    }
  }

  ngAfterViewInit() {
    this.getCustomTemplate();
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.removeEventListener();
  }

  addEventListener() {
    this.removeEventListener();

    this.subscriptions.push(
      this.dataService.getClickEvent().subscribe((target) => {
        if(target.isHideOverlay) this.closeOverlay();
        if (!this.overlayContainer.nativeElement.contains(target)) {
          if (this.closeOnClickOutside && this.isOverlayVisible) {
            this.closeOverlay();
          }
        }
      })
    );

    if (this.closeOnTab) {
      this.subscriptions.push(
        this.dataService.getKeyPressEvent().subscribe((event) => {
          if (event.key === 'Escape' || (event.key === 'Tab' && this.closeOnTab)) {
            this.closeOverlay();
          }
        })
      );
    }
  }

  closeAfterActionFn() {
    this.closeOverlay();
  }

  // Removing listeners
  removeEventListener() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  // Opening overlay and attaching listeners
  showOverlay = (type?: string, event?) => {
    if (this.stopPropagation && type === 'click') {
      event.preventDefault();
      event.stopPropagation();
    }

    if (type === 'focus' && !this.showOnTab) return;
    else if (type === 'hover' && !this.showOnHover && !this.disabled) return;
    else if (type === 'click' && !this.showOnClick) return;

    if (this.disabled) return;

    if (this.isOverlayVisible) {
      this.closeOverlay();
    } else {
      this.appShow.emit();
      this.isOverlayVisible = true;
      this.addEventListener();
    }
  };

  // Closing overlay and detaching listeners
  closeOverlay = (type?: string) => {
    if (type === 'hover' && !this.showOnHover) return;

    this.appHide.emit();
    this.isOverlayVisible = false;
    this.cdr.detectChanges();
    this.removeEventListener();
  };

  // Getting all the templates
  getCustomTemplate() {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'item':
          this.itemTemplate = item.template;
          break;

        case 'overlay':
          this.overlayTemplate = item.template;
          break;
      }
    });
  }
}
